// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "84feeba54a0e242fc7cb97af21cb2f9be77e4742/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};